module.exports = __webpack_public_path__ + "static/img/pic_mkd_logo.bf5eb12d.png";